import { render, staticRenderFns } from "./myinfo.vue?vue&type=template&id=01289238&scoped=true"
import script from "./myinfo.vue?vue&type=script&lang=js"
export * from "./myinfo.vue?vue&type=script&lang=js"
import style0 from "./myinfo.vue?vue&type=style&index=0&id=01289238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01289238",
  null
  
)

export default component.exports